(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regsup-product"]) return;
  try {
    
  if (!customElements.get('regsup-product-page')) {
    customElements.define('regsup-product-page', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const dialog = this.querySelector('dialog');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-ru-preview]');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const image = new Image();
          image.src = link.href;
          image.alt = link.dataset.ruAlt || '';
          this.querySelector('[data-ru-zoom-content]').replaceChildren(image);
          dialog.showModal();
        });
        this.querySelector('[data-ru-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target === dialog) {
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regsup-storefront"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('regsup-product-showcase')) {
  customElements.define('regsup-product-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.index = 0;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-slide-to]')];
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hovered = false;
      this.toggle = this.querySelector('[data-toggle]');
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index, true)));
      this.querySelector('[data-previous]').addEventListener('click', () => this.select(this.index - 1, true));
      this.querySelector('[data-next]').addEventListener('click', () => this.select(this.index + 1, true));
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.refresh(); });
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); });
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); });
      this.addEventListener('focusin', () => this.schedule());
      this.addEventListener('focusout', () => setTimeout(() => this.schedule(), 0));
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (!event.target.closest('.rs-slider-controls')) return;
        event.preventDefault();
        this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
      });
      this.visibility = () => this.schedule();
      this.reduced = () => { if (this.motion.matches) this.paused = true; this.refresh(); };
      document.addEventListener('visibilitychange', this.visibility);
      this.motion.addEventListener('change', this.reduced);
      this.classList.add('is-ready');
      this.refresh();
    }
    select(next, manual = false) {
      if (!this.slides.length) return;
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
      this.dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === this.index)));
      if (manual) {
        this.paused = true;
        this.querySelector('[data-slide-announcement]').textContent = this.slides[this.index].getAttribute('aria-label');
      }
      this.refresh();
    }
    refresh() {
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
      this.toggle.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || document.hidden || this.contains(document.activeElement) || this.slides.length < 2) return;
      this.timer = setTimeout(() => this.select(this.index + 1), 7000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.visibility);
      this.motion?.removeEventListener('change', this.reduced);
    }
  });
}
if (!customElements.get('regsup-product-rail')) {
  customElements.define('regsup-product-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.rail = this.querySelector('[data-rail]');
      this.prev = this.querySelector('[data-rail-prev]');
      this.next = this.querySelector('[data-rail-next]');
      this.update = () => {
        this.prev.disabled = this.rail.scrollLeft < 4;
        this.next.disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 4;
      };
      const move = direction => this.rail.scrollBy({ left: direction * (this.rail.clientWidth + 18), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.prev.addEventListener('click', () => move(-1));
      this.next.addEventListener('click', () => move(1));
      this.rail.addEventListener('scroll', this.update, { passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.rail);
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
